/* eslint-disable*/
import React from 'react';
import './CarteParticulier.scss';
import { useNavigate } from 'react-router-dom';

const CarteParticulier = function CarteParticulier({ img, name, ville }) {
  const navigate = useNavigate();
  return (
    <div className="shadow flex flex-col w-full lg:w-4/5 h-full lg:mx-6 rounded-xl items-center text-center justify-center bg-gray-100 p-4 lg:py-auto mb-8 lg:mb-0">
      <img className="w-20 h-20 rounded-full" src={img} alt="avatar" />
      <div className="m-3">
        <h1 className="text-2xl m-1 font-semibold">{name}</h1>
        <h4 className="m-1 font-semibold">{ville}</h4>
        <h4 className="m-1">4 answers</h4>
      </div>
      <div className="mb-2 w-48">
        <button
          type="button"
          className="button"
          onClick={() => navigate('/contact')}
        >
          Contact Me
        </button>
      </div>
    </div>
  );
};

export default CarteParticulier;
